import React from 'react';
import Editor from '@teetsh/app/src/components/Editor/Loadable';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export function TextCustomField(props: Props) {
  const { value, onChange } = props;
  return (
    <Editor
      inline
      minimal={false}
      value={value || ''}
      onChange={e => onChange(e)}
    />
  );
}
